import React from 'react';
import { Separator } from './styles';

export default (props) => <Separator {...props} />;
